import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Modal from '../../../../components/Modal/Modal';
import { SectionButton } from '../../styles/GerenciarContas.styles';
import Button from '../../../../components/Button/Button';
import SelectOptions from '../../../../components/SelectOptions';
import { useMemo, useState } from 'react';
import InputFormatValue from '../../../../components/InputFormatValue';
import { showAlert } from '../../../../store/ducks/sweetAlert';
import * as S from './ManageBalance.styles';
import { useEffect } from 'react';
import {
  tariffsCreditFetchAction,
  tariffsDebitFetchAction,
  tariffsFetchAction,
} from '../../../../store/fetchActions/tariffsActions';
import TextField from '../../../../components/TextField';
import { useTheme } from 'styled-components';

const ManageBalance = ({ openModal, closeModal, idConta }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [type, setType] = useState();
  const [idTarifa, setIDTarifa] = useState();

  const submitTariffs = (data) => {
    const params = {
      ID_CONTA: idConta,
      ID_TARIFA: data.taxas_tarifa,
      VALOR: data.valor.replace('R$', '').replace(/\s/g, ''),
      ID_COBAN: usersData?.ID_COBAN,
      DESC_TARIFA: data.descricao,
    };

    if (data.valor === undefined || data.valor === 'R$ 0,00' || data.valor === '0.00') {
      dispatch(
        showAlert({
          title: 'Atenção!',
          text: 'O valor informado , deverá ser maior que 0!',
          icon: 'warning',
        }),
      );
    } else {
      type === 'CREDITAR' && dispatch(tariffsCreditFetchAction(params, closeModal, usersData.CPFCNPJ));
      type === 'DEBITAR' && dispatch(tariffsDebitFetchAction(params, closeModal, usersData.CPFCNPJ));
    }
  };

  const { detailAccountBalanceData, detailAccountsData } = useSelector((state) => state.account);
  const { usersData } = useSelector((state) => state.user);
  const { tariffsData } = useSelector((selector) => selector.tariffs);

  const { handleSubmit: handleBlockUser, control: controlBlockUser, setValue } = useForm({});

  useEffect(() => {
    dispatch(tariffsFetchAction(usersData?.ID_COBAN));
  }, [usersData?.ID_COBAN]);

  const tarifas = useMemo(() => {
    return tariffsData?.map((val) => {
      return { ID: val.ID, NOME: val.DESCRICAO };
    });
  }, [tariffsData]);

  useMemo(() => {
    return tariffsData?.filter((val) => val.ID == idTarifa && setValue('valor', val.VALOR));
  }, [idTarifa]);

  return (
    <Modal open={openModal} close={closeModal} title={'Gerenciar saldo/ tarifa/ taxas'} width={'40vw'}>
      <S.SubTitle>
        <h5>Conta: {detailAccountsData?.conta?.CONTA}</h5>
        <h5>Saldo atual: {detailAccountBalanceData?.saldo}</h5>
      </S.SubTitle>
      <form onSubmit={handleBlockUser(submitTariffs)}>
        <S.FormSectionInput>
          <S.ConteinerInput>
            <SelectOptions
              control={controlBlockUser}
              options={tarifas}
              name={'taxas_tarifa'}
              width={'100%'}
              label={'Taxas/ Tarifas'}
              required={true}
              onClick={(e) => setIDTarifa(e?.ID)}
            />
          </S.ConteinerInput>
          <S.ConteinerInput>
            <InputFormatValue
              control={controlBlockUser}
              label={'Valor'}
              width={'100%'}
              name={'valor'}
              required={true}
            />
          </S.ConteinerInput>
          <S.ConteinerInput>
            <TextField name={'descricao'} label={'Descrição'} fullWidth multiline={true} control={controlBlockUser} />
          </S.ConteinerInput>
        </S.FormSectionInput>
        <SectionButton>
          <Button
            backgroundcolor={theme.colors.veryDarkDesaturatedBlue}
            width={'16.792vw'}
            height={'3.125vw'}
            hoverbgcolor={theme.colors.veryDarkDesaturatedBlue}
            hovercolor={theme.colors.white}
            mycolor={theme.colors.white}
            type={'submit'}
            onClick={() => setType('DEBITAR')}
          >
            <span>DEBITAR (RETIRAR)</span>
          </Button>
          <Button
            backgroundcolor={theme.colors.darklimeGreen}
            width={'16.792vw'}
            height={'3.125vw'}
            hoverbgcolor={theme.colors.darklimeGreen}
            hovercolor={theme.colors.white}
            mycolor={theme.colors.white}
            type={'submit'}
            onClick={() => setType('CREDITAR')}
          >
            <span>CREDITAR (ADICIONAR)</span>
          </Button>
        </SectionButton>
      </form>
    </Modal>
  );
};

export default ManageBalance;
